import { createContext, useContext, type PropsWithChildren } from "react";

export type AdminRuntimeValue = {
  mode: "development" | "cloud";
  username?: string;
  signOut?: () => Promise<void>;
  apiBaseUrl?: string;
  getAccessToken?: () => Promise<string>;
};

const AdminRuntimeContext = createContext<AdminRuntimeValue>({ mode: "development" });

export function AdminRuntimeProvider({ value, children }: PropsWithChildren<{ value: AdminRuntimeValue }>) {
  return <AdminRuntimeContext.Provider value={value}>{children}</AdminRuntimeContext.Provider>;
}

export function useAdminRuntime(): AdminRuntimeValue {
  return useContext(AdminRuntimeContext);
}
